import { css } from '@emotion/css'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Vulnerability } from '../../../../components/shared'
import { StatusBreakdownWithTotal } from '../../../../components/thermometer/severity-thermometer'
import { VulnerabilitySeverity } from '../../../../components/vulnerabilities-grid/shared'
import { Severity, VulnerabilitySeverityBadge } from '../severity'
import { CvssScoringType } from '../../helpers/ui-interfaces'
import { LibraryVulnerabilityTooltipEntry } from '../library/library-vulnerability-tooltip-entry'

interface Props {
  severity?: string
  severityData: StatusBreakdownWithTotal
  setIsModalOpen?: React.Dispatch<boolean>
  setModalVulnerability?: React.Dispatch<
    React.SetStateAction<Vulnerability | undefined>
  >
  cvssScoringType?: CvssScoringType
  showCveData?: boolean
}

export const VulnerabilitiesTooltip = ({
  severity,
  severityData,
  setIsModalOpen,
  setModalVulnerability,
  cvssScoringType,
  showCveData = true
}: Props) => {
  if (severityData.total < 1) {
    return (
      <FormattedMessage id="detail_libraries_noVulnerabilitiesFoundForLibrary" />
    )
  }

  const severities: string[] = severity
    ? [severity]
    : ['critical', 'high', 'medium', 'low', 'note']

  const severityNodes: React.ReactNode[] = Object.keys(severityData)
    .filter(
      (severityFilterKey) =>
        severities.includes(severityFilterKey) &&
        severityData[severityFilterKey].total > 0
    )
    .map((severityKey: string, index) => {
      return (
        <div
          key={index}
          className={css`
            flex: 1 1 50%;
            margin-bottom: 5px;
          `}
        >
          <div>
            <div
              className={css`
                display: flex;
                align-items: center;
                margin-bottom: 6px;
                font-size: 14px;
              `}
            >
              {showCveData ? (
                <>
                  <div
                    className={css`
                      padding-right: 7px;
                    `}
                  >
                    {severityData[severityKey].total}{' '}
                  </div>
                  <VulnerabilitySeverityBadge
                    severity={Severity.fromName(
                      severityKey.toUpperCase() as VulnerabilitySeverity
                    )}
                  />
                </>
              ) : (
                <>
                  <div
                    className={css`
                      padding-right: 3px;
                      font-weight: 600;
                    `}
                  >
                    {severityData[severityKey].total}
                  </div>
                  <div
                    className={css`
                      div:first-letter {
                        text-transform: capitalize;
                      }
                      font-weight: 600;
                    `}
                  >
                    <div>{severityKey}</div>
                  </div>
                </>
              )}
            </div>
          </div>
          {showCveData &&
            severityData[severityKey].vulnerabilities.map((vulnerability) => {
              return (
                <LibraryVulnerabilityTooltipEntry
                  key={vulnerability.name}
                  vulnerability={{
                    ...vulnerability,
                    hasCve: vulnerability.hasCVE
                      ? vulnerability.hasCVE
                      : vulnerability.hasCve
                  }}
                  setIsModalOpen={setIsModalOpen}
                  setModalVulnerability={setModalVulnerability}
                  cvssScoringType={cvssScoringType}
                />
              )
            })}
        </div>
      )
    })
  return (
    <div
      className={css`
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
      `}
    >
      {severityNodes}
    </div>
  )
}
